<template>
  <div class="container greyPage">
    <van-nav-bar title="捐赠积分" left-text fixed left-arrow @click-left="$router.go(-1)" />
    <div class="padding15">
      <van-form validate-first @submit="onSubmit">
        <!-- <van-field v-model="form.phone" name="phone" placeholder="请输入已转增的手机号" :rules="[
            { validator: asyncValidatorPhone, message: '请输入正确的手机号' },
          ]" /> -->
        <van-field readonly clickable name="phone" v-model="form.phone" placeholder="选择捐赠账户" @click="showPicker = true" :rules="[{ required: true, message: '请选择捐赠账户' }]" />
        <van-popup v-model="showPicker" position="bottom">
          <van-picker show-toolbar :columns="donationList" value-key="name" @confirm="onConfirm" @cancel="showPicker = false" />
        </van-popup>
        <van-field v-model.number="form.integral" name="integral" placeholder="请输入要捐赠的积分数额" :rules="[{ validator: validatorNumber, message: '请输入正确的积分，且不可大于可用积分' }]" />
        <van-row class="textAlignRight marginTop6">
          <van-col :span="24"><span></span>当前可用积分：{{ userInfo.integral }}</van-col>
        </van-row>
        <div style="margin: 16px">
          <van-button round block type="primary" native-type="submit" :disabled="submitLoading" :loading="submitLoading" loading-text="正在提交...">提交</van-button>
        </div>
      </van-form>
    </div>
  </div>
</template>

<script>
import { donationPullList, donateIntegral } from "@/api/data";
export default {
  data() {
    return {
      form: {
        phone: "",
        integral: "",
      },
      donationList: [],
      showPicker: false,
      submitLoading: false,
    };
  },
  created() {
    this.getPullList()
  },
  computed: {
    userInfo() {
      return this.$store.state.userInfo
    },
  },
  methods: {
    onConfirm(value) {
      console.log(value);
      this.form.phone = value.phone;
      this.showPicker = false;
    },
    getPullList() {
      donationPullList({}).then(res => {
        if (res) {
          res.data.forEach(item => {
            item.name = item.realName + '-' + item.phone
          })
          this.donationList = res.data
        }
      })
    },
    validatorNumber(val) {
      let _this = this
      return new Promise((resolve) => {
        if (!/^[1-9]\d*$/.test(val)) {
          resolve(false)
        }
        if (val > _this.userInfo.integral) {
          resolve(false)
        }
        resolve(true)
      });
    },

    onSubmit(values) {
      let _this = this;
      _this.submitLoading = true;
      donateIntegral(values).then((res) => {
        if (res) {
          _this.$toast({
            message: "捐赠成功",
            position: "bottom",
          });
          setTimeout(() => {
            _this.$router.push({ name: "donateList" });
            _this.$store.dispatch("getInfo")
          }, 1000);
        }
        _this.submitLoading = false;
      }).catch(()=>{
        this.submitLoading = false
      });
    },
  },
};
</script>

<style >
</style>